export default {
  apiEndPoint: 'https://go.replayer.it/api',
  sharedVideoBaseUrl: 'https://go.replayer.it/v',
  paypalClientId: 'AW_xmRMDSw2_YtB6nIcI5VV3xo96nCjfILKVJIUK3-9QF9Fq15N2b3Q_T3ja0iINsoB_PebI1y3HEard',
  paypalMerchantId: 'BGNUQWRQ9YHNE',
  googleClientId: '983057732726-d68ag6hibekad7hgmp0vni4444argn92.apps.googleusercontent.com',
  appleClientId: 'it.replayer.web',
  appleRedirectUri: 'https://go.replayer.it/login',
  baseUrl: 'https://go.replayer.it',
  krpanoPlayerUrl: 'https://go.replayer.it/krpano/',
  satispayEnabled: true,
  videoAnalysisReplayerUiEnabled: true
};
